import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Users
export const getUsers = () => axios.get(`${API}/users`);
export const createUser = (data) => axios.post(`${API}/users`, data);
export const updateUser = (userId, data) => axios.put(`${API}/users/${userId}`, data);
export const deleteUser = (userId) => axios.delete(`${API}/users/${userId}`);

// Vendors
export const getVendors = () => axios.get(`${API}/vendors`);
export const createVendor = (data) => axios.post(`${API}/vendors`, data);
export const updateVendor = (vendorId, data) => axios.put(`${API}/vendors/${vendorId}`, data);
export const deleteVendor = (vendorId, pin) => axios.post(`${API}/vendors/${vendorId}/delete`, { pin });

// Banks
export const createBank = (data) => axios.post(`${API}/banks`, data);
export const updateBank = (vendorId, bankId, data) => axios.put(`${API}/banks/${vendorId}/${bankId}`, data);
export const deleteBank = (vendorId, bankId, pin) => axios.post(`${API}/banks/${vendorId}/${bankId}/delete`, { pin });
export const checkAccountNumber = (accountNumber) => axios.get(`${API}/banks/check-account/${accountNumber}`);

// Dashboard
export const getDashboardMetrics = () => axios.get(`${API}/dashboard/metrics`);

// Export
export const exportSummary = () => axios.get(`${API}/export/summary`);
export const exportAllBanks = () => axios.get(`${API}/export/banks`);
export const exportVendorBanks = (vendorId) => axios.get(`${API}/export/vendor-banks/${vendorId}`);

// Delete PIN
export const setDeletePin = (pin, password) => axios.post(`${API}/auth/set-delete-pin`, { pin, password });
export const logoutAllDevices = () => axios.post(`${API}/auth/logout-all`);
export const verifyDeletePin = (pin) => axios.post(`${API}/auth/verify-delete-pin`, { pin });

// Activity Logs
export const getActivityLogs = (params) => axios.get(`${API}/activity-logs`, { params });

// Recharges
export const addRecharge = (vendorId, bankId, data) => axios.post(`${API}/banks/${vendorId}/${bankId}/recharges`, data);
export const deleteRecharge = (vendorId, bankId, rechargeId) => axios.post(`${API}/banks/${vendorId}/${bankId}/recharges/${rechargeId}/delete`);

// Settings - Credential Types
export const getCredentialTypes = () => axios.get(`${API}/settings/credential-types`);
export const addCredentialType = (name) => axios.post(`${API}/settings/credential-types`, { name });
export const deleteCredentialType = (typeName) => axios.delete(`${API}/settings/credential-types/${encodeURIComponent(typeName)}`);

// Partners
export const getPartners = () => axios.get(`${API}/partners`);
export const createPartner = (data) => axios.post(`${API}/partners`, data);
export const updatePartner = (partnerId, data) => axios.put(`${API}/partners/${partnerId}`, data);
export const deletePartner = (partnerId) => axios.delete(`${API}/partners/${partnerId}`);
export const assignPartner = (vendorId, bankId, partnerId) => axios.post(`${API}/banks/${vendorId}/${bankId}/assign-partner`, { partnerId });
export const getPartnerBanks = () => axios.get(`${API}/partner/banks`);

// Verification
export const updateVerification = (vendorId, bankId, checkName, data) => axios.put(`${API}/banks/${vendorId}/${bankId}/verification/${checkName}`, data);

// Activity Logs Export
export const exportActivityLogsCsv = (params) => axios.get(`${API}/activity-logs/export/csv`, { params });

// Settings - Wipe Database
export const requestStepUp = (body) => axios.post(`${API}/security/step-up`, body);
export const wipeDatabase = (requestId, code) =>
  axios.delete(`${API}/settings/wipe-data`, { data: { requestId, code } });

// Phone Numbers
export const getPhoneNumbers = () => axios.get(`${API}/phone-numbers`);

// All Banks (flat)
export const getAllBanks = () => axios.get(`${API}/all-banks`);

// Full bank detail (with DataUrl fields)
export const getBankFull = (vendorId, bankId) => axios.get(`${API}/vendors/${vendorId}/banks/${bankId}`);

// Partner banks by ID (admin)
export const getPartnerBanksById = (partnerId) => axios.get(`${API}/partner/${partnerId}/banks`);

// Companies (Super Admin)
export const getCompanies = () => axios.get(`${API}/companies`);
export const getCompany = (companyId) => axios.get(`${API}/companies/${companyId}`);
export const createCompany = (data) => axios.post(`${API}/companies`, data);
export const updateCompany = (companyId, data) => axios.put(`${API}/companies/${companyId}`, data);
export const deleteCompany = (companyId, requestId, code) => axios.delete(`${API}/companies/${companyId}`, { data: { requestId, code } });
export const impersonateAdmin = (companyId) => axios.post(`${API}/companies/${companyId}/impersonate`);

// Exports (PDF/Excel)
export const exportBankFile = (vendorId, bankId, format = 'excel') =>
  axios.get(`${API}/export/bank/${vendorId}/${bankId}?format=${format}`, { responseType: 'blob' });
export const exportVendorFile = (vendorId, format = 'excel') =>
  axios.get(`${API}/export/vendor/${vendorId}?format=${format}`, { responseType: 'blob' });
export const exportAllBanksFile = (format = 'excel') =>
  axios.get(`${API}/export/all-banks?format=${format}`, { responseType: 'blob' });
export const exportFilteredFile = (filterType, format = 'excel') =>
  axios.get(`${API}/export/filtered?filter_type=${filterType}&format=${format}`, { responseType: 'blob' });

// Upload
export const downloadUploadTemplate = () =>
  axios.get(`${API}/banks/upload-template`, { responseType: 'blob' });
export const uploadBanksExcel = (formData) =>
  axios.post(`${API}/banks/upload`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const customImportExcel = (formData) =>
  axios.post(`${API}/banks/custom-import`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

// OCR
export const extractOCR = (imageDataUrl, documentType) =>
  axios.post(`${API}/ocr/extract`, { image_data_url: imageDataUrl, document_type: documentType });

// Reports
export const getReportMeta = () => axios.get(`${API}/reports/meta`);
export const queryReport = (filters) => axios.post(`${API}/reports/query`, filters);
export const exportReport = (format, filters) => axios.post(`${API}/reports/export/${format}`, filters, { responseType: 'blob' });
export const saveReportFilter = (name, filters) => axios.post(`${API}/reports/save-filter`, { name, filters });
export const deleteSavedFilter = (id) => axios.delete(`${API}/reports/saved-filter/${id}`);
export const getVendorSummary = () => axios.get(`${API}/reports/vendor-summary`);
export const getDownloadHistory = (limit = 50, skip = 0) => axios.get(`${API}/export/download-history?limit=${limit}&skip=${skip}`);
export const deleteDownloadLog = (id) => axios.delete(`${API}/export/download-history/${id}`);

// Upload settings (per-company)
export const getUploadSettings = () => axios.get(`${API}/settings/upload`);
export const updateUploadSettings = (data) => axios.put(`${API}/settings/upload`, data);

// Filtered Excel/PDF export of explicit bank IDs (Banks page)
export const exportBanksByIds = (bankIds, format = 'excel', filterLabel = '') =>
  axios.post(
    `${API}/export/by-ids`,
    { bankIds, format, filterLabel },
    { responseType: 'blob' }
  );

// Lightweight KPI counts for Banks page (avoids loading full list at scale)
export const getAllBanksStats = () => axios.get(`${API}/all-banks/stats`);

// Scheduled reports
export const listReportSchedules = () => axios.get(`${API}/report-schedules`);
export const createReportSchedule = (data) => axios.post(`${API}/report-schedules`, data);
export const toggleReportSchedule = (id, enabled) => axios.put(`${API}/report-schedules/${id}`, { enabled });
export const deleteReportSchedule = (id) => axios.delete(`${API}/report-schedules/${id}`);

// Multipart screenshot upload — bypasses JSON body limits on production ingress.
export const uploadVerificationScreenshot = (vendorId, bankId, checkName, file, notes = '') => {
  const fd = new FormData();
  fd.append('file', file);
  if (notes) fd.append('notes', notes);
  return axios.post(
    `${API}/banks/${vendorId}/${bankId}/verification/${checkName}/screenshot`,
    fd,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
};

// Generic bank attachment multipart upload (KYC, cards, opening docs, QR, freeze).
// `field` must be one of: aadhaar, pan, debitCard, creditCard, openingScreenshot,
// openingStatement, qr, freezeAttachment.
export const uploadBankAttachment = (vendorId, bankId, field, file, { cardIndex = -1 } = {}) => {
  const fd = new FormData();
  fd.append('file', file);
  if (cardIndex >= 0) fd.append('card_index', String(cardIndex));
  return axios.post(
    `${API}/banks/${vendorId}/${bankId}/upload/${field}`,
    fd,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
};
